export const Integration = {
    ClickUp: "CLICKUP",
    AirtTable: "AIRTABLE"
}